let expanded = false;
const recommendationContainer = document.querySelector(".tangent-recommendation-container");
const loaderWrapper = document.querySelector(".tangent-loader-wrapper");

document.addEventListener("DOMContentLoaded", (event) => {
    TangentAI.init();
});

const TangentAI = (function () {
    const init = () => {
        const window_url = new URL(window.location.href);
        response_id = window_url.searchParams.get("resp_id");
        TangentAI.fetchRecommendation(response_id)
            .then((recommendationData) =>
                TangentAI.displayRecommendation(recommendationData)
            )
            .catch((e) => console.log(e));
    };

    const fetchRecommendation = async (resp_id) => {
        try {
            let response = await fetch(
                `https://service.tangent.ai/shopify/get-checkout-products?resp_id=${resp_id}&self_serve=true&multiple_variants=true`
            );
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            let globalData = await response.json();
            return globalData;
        } catch (error) {
            console.error("Error fetching data:", error);
            return null;
        }
    };

    const displayRecommendation = (data) => {
        let selectedVariants = TangentAI.getSelectedVariantsObject(
            data.products
        );
        let recommendedProducts = TangentAI.getRecommendedProductDetails(
            selectedVariants,
            data.products
        );
        if(recommendedProducts.length === 0){
          renderErrorMessage()
        }
      
        renderProductDetails(recommendedProducts);
        // addClickHandler(product);
        loaderWrapper.style.display = "none";
        recommendationContainer.style.display = "flex";
    };

    const renderProductDetails = (products) => {
        const primaryProduct = products[0];
        const productContainer = document.querySelector(".tangent-recommendation-container");
        let productBlock = document.createElement("div");
        productBlock.className = "recommendation-block";
        const productImage = renderProductImage(primaryProduct);
        const productDetails = renderProductBlock(products);
        productBlock.innerHTML = productImage;
        productBlock.innerHTML += productDetails;
        productContainer.appendChild(productBlock);
    }

    const renderProductImage = (product) => {
        return `<div class='primary-product-image-block'><a class='primary-product-link' href='${product.productURL}' target='_blank'><img class='primary-product-image' src='${product.imageUrl ? product.imageUrl : product.variantImage}'/></a></div>`
    }

    const renderErrorMessage=()=>{
        recommendationContainer.innerHTML = `<p class="error-message">Product or variant not available, please try again.</p>`
        loaderWrapper.style.display = "none";
        recommendationContainer.style.display = "flex";
    }

    const renderProductBlock = (products) => {
        const primaryProduct = products[0];
        const secondaryProduct = products[1];
        const ternaryProduct = products[2];
        return `
        <div class='primary-product-detail-block'>
            <div class='product-details'>
                <p class='product-recommendation-title'>Your best choice</p>
                <p class='primary-product-title'>${primaryProduct.title}</p>
                <p class='primary-product-subtitle'>${primaryProduct.subtitle}</p>
                <p class='primary-product-price'>£${primaryProduct.price}</p>
            </div>
            <div class='read-more-container'>
                <div class='description-wrapper' id='descWrapper'>
                    <p class='description'>${primaryProduct.descriptionHtml}</p>
                </div>
                <p class='readmore-btn' id='toggleBtn' onclick='handleClick()'>Read more</p>
            </div>
            <div class='primary-feature-block'>
                <div class='feature-block'>
                    <p class='feature-title'>FIRMNESS</p>
                    <p class='feature-value'>${primaryProduct.productFirmness}</p>
                </div>    
            </div>
            <div class='add-to-cart-block'>
                <button class='add-to-cart-btn' data-variantid='${primaryProduct.variantId}'>ADD TO CART</button>
            </div>
            <div class='secondary-products-block'>
                <div class='sub-product-block'>
                    <img class='secondary-product-img' src='${secondaryProduct.imageUrl}' />
                    <div class='secondary-product-detail'>
                        <div>
                            <p class='secondary-reco-title'>Your second best pillow match</p>
                            <p class='secondary-product-title'>${secondaryProduct.title}</p>
                        </div>
                        <a class='further-detail-btn' href='${secondaryProduct.productURL}' target='_blank'>Further details</a>
                    </div>
                </div>
                <div class='sub-product-block'>
                    <img class='secondary-product-img' src='${ternaryProduct.imageUrl}' />
                    <div class='secondary-product-detail'>
                        <div>
                            <p class='secondary-reco-title'>Your third best pillow match</p>
                            <p class='secondary-product-title'>${ternaryProduct.title}</p>
                        </div>
                        <a class='further-detail-btn' href='${ternaryProduct.productURL}' target='_blank'>Further details</a>
                    </div>
                </div>
            </div>
        </div>
        `
    }

    const getSelectedVariantsObject = (individualProducts) => {
        const filteredObject = {};
        // Iterate through the array of individual product IDs
        individualProducts.forEach((product) => {
            const variantLists = product?.variants?.edges
            if(variantLists.length > 0){
                filteredObject[product.id] = variantLists[0];
            }
        });
        return filteredObject;
    };

    const getRecommendedProductDetails = (selectedVariants, productList) => {
        let resultedProducts = [];
        // Map through selected variants and match them with products
        for (let productId in selectedVariants) {
            let matchingProduct = filterList(productList, productId); //get matching product
            let matchingVariant = selectedVariants[productId];
            if (matchingProduct && matchingVariant) {
                let productDetails = {
                    title: matchingProduct.title,
                    subtitle: matchingProduct?.subtitle?.value,
                    handle: matchingProduct.handle,
                    description: matchingProduct.description,
                    descriptionHtml: matchingProduct.descriptionHtml,
                    productId: matchingProduct.id,
                    variantId: matchingVariant.node.id.split("/").pop(),
                    variantTitle: matchingVariant.node.title,
                    productURL: getProductURL(matchingVariant.node.id.split("/").pop(), matchingProduct.handle),
                    variantImage: matchingVariant.node.image?.url,
                    productSize: getSelectedOption(matchingVariant, "Size"),
                    productFirmness: getSelectedOption(matchingVariant, "Firmness"),
                    price: matchingVariant.node.price,
                    isVariantAvailable: isVariantAvalaible(
                        matchingProduct,
                        matchingVariant.node
                    ),
                    imageUrl: matchingProduct.images.nodes[0].url,
                    imageAlt: `${matchingProduct.title} image`,
                };
                resultedProducts.push(productDetails);
            }
        }
        return resultedProducts;
    };

    //event handler for add to cart button
    // const addClickHandler = () => {
    //     const addToCartBtns = document.querySelectorAll(".add-to-cart-btn");
    //     if (addToCartBtns.length === 0) return;
    //     addToCartBtns.forEach((btn) => {
    //         btn.addEventListener("click", () => {
    //             addVariantsToCart(btn.dataset.variantid);
    //         });
    //     })
    // }

    //get product size
    const getSelectedOption = (variant, selectedOption) => {
        const options = variant?.node?.selectedOptions;
        for(let option of options){
            if(option.name == selectedOption){
                return option.value
            }
        }
    }

    //to get the pruduct URL
    const getProductURL = (variantID, handle) => {
        return `${window.location.origin}/products/${handle}?variant=${variantID}`;
    };

    //get the single item from an array with a matching id
    const filterList = (lists, matchingId) => {
        return lists.find((list) => {
            const id = list.id || list.node?.id.split("/").pop();
            return id == matchingId;
        });
    };

    //get image slug
    const getImageSlug = (slugOrigin, slugName, fileType) => {
        return `${slugOrigin}/${slugName
            .toLowerCase()
            .replaceAll(" ", "-")}.${fileType}`;
    };

    //check variant availability
    const isVariantAvalaible = (product, variant) => {
        if (product.status == "ARCHIVED") {
            return false;
        } else {
            return (
                variant.inventoryQuantity > 0 || variant.inventoryPolicy === "CONTINUE"
            );
        }
    };

    return {
        init,
        fetchRecommendation,
        displayRecommendation,
        getSelectedVariantsObject,
        getRecommendedProductDetails,
    };
})();

const handleClick = () => {
    const wrapper = document.getElementById("descWrapper");
    const button = document.getElementById("toggleBtn");
    const collapsedHeight = parseFloat(getComputedStyle(document.querySelector(".description")).lineHeight) * 2;
    expanded = !expanded;
    if (expanded) {
        wrapper.style.maxHeight = wrapper.scrollHeight + "px";
        button.textContent = "Read less";
    } else {
        wrapper.style.maxHeight = collapsedHeight + "px";
        button.textContent = "Read more";
  }
}

document.addEventListener('click', (e) => {
    if (e.target.matches('.add-to-cart-btn')) {
        addToCart(e.target.dataset.variantid, e.target);
    }
});

function addToCart(variantid, element){ 
    const formData = createFormDataFromIds([variantid]);
    addToCartApi(formData, element);
    element.innerHTML = `<span class='loadingBtn'></span>`;
}

function addToCartApi(payload, element){
    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    }).then(() => {
         element.innerHTML = "ADD TO CART";
    }).catch((error) => {
        console.error('Error:', error);
    });
}

function createFormDataFromIds(idArray) {
    const items = idArray.map(id => {
        const baseItem = { id, quantity: 1 };
        return baseItem;
    });
    return { items };
}
